export const gooogleApiKey = 'AIzaSyAOrI9daMiZzf1t2oPscaFD4FpPod4yTR8'
export const googleGeocoding = 'https://maps.googleapis.com/maps/api/geocode'
